import styled from 'styled-components'

import {media} from '@/src/config/theme'

import {UI} from '@/src/shared/ui/inputs/readable-input'
import {FormInput} from "@/src/shared/ui/inputs/input";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const Input = styled(FormInput)``

export const FieldsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  gap: 15px;

  & > * {
    flex: 1;
  }

  & ${UI.ViewLabel} {
    flex: auto;
  }

  @media ${media.md} {
    flex-direction: row;
  }
`
